// extracted by mini-css-extract-plugin
export default {"featuresList":"styles_featuresList__iHP+y"};